import React from "react";
import styled from "styled-components";
import { withTheme } from "@material-ui/core/styles";

import { CardElement } from "@stripe/react-stripe-js";

const StyledStripeInput = styled.div`
  background-color: ${(props) => props.theme.palette.primary.dark};
  border-radius: ${(props) => props.theme.border.radius};
  box-shadow: ${(props) =>
    props.theme.border.shadow + props.theme.palette.primary.dark};

  width: 100%;
  padding: 1.75vh 0vh;
  margin: 1.5vh auto;

  div {
    // flex-grow: 0;
    // flex-shrink: 0;
    // flex-basis: 100%;

    &.StripeElement {
      color: ${(props) => props.theme.palette.secondary.main};
    }

    &.StripeElement--focus {
      color: ${(props) => props.theme.palette.secondary.light};
    }

    &.StripeElement--invalid {
      color: ${(props) => props.theme.palette.red.main};
      // box-shadow: ${(props) =>
        props.theme.border.shadow + props.theme.palette.red.dark};
    }

    &.StripeElement--webkit-autofill {
      color: ${(props) => props.theme.palette.secondary.light}!important;
      background: transparent !important;
      fontsize: 14px !important;
    }
  }
  div:nth-child(1) {
    min-width: 150px;
  }
  div:nth-child(2) {
    min-width: 150px;
  }
  div:nth-child(3) {
    min-width: 150px;
  }
`;

const StripeInput = (props) => {
  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: props.theme.palette.secondary.light,
        iconColor: props.theme.palette.secondary.light,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "14px",
        "::placeholder": {
          color: props.theme.palette.secondary.dark,
        },
        fontWeight: 600,
        ":-webkit-autofill": {
          color: props.theme.palette.secondary.light,
          backgroundColor: "none",
        },
      },
      invalid: {
        color: props.theme.palette.red.main,
        iconColor: props.theme.palette.red.main,
      },
    },
  };

  return (
    <StyledStripeInput>
      <CardElement
        options={CARD_ELEMENT_OPTIONS}
        onChange={() => props.setError(null)}
      />
    </StyledStripeInput>
  );
};

export default withTheme(StripeInput);
